// Sections of the Swiper Studio page, in order. The active one lives in the
// URL (?tab=...), so the browser Back button walks back through them.
import { FaEye, FaImages, FaInfoCircle, FaMagic, FaMobileAlt, FaPalette, FaShapes, FaSlidersH } from "react-icons/fa";
import { elakayAutoText } from "../pageInside/dataElakay";

const text = elakayAutoText;

export const STUDIO_PATH = "/elakay/swipers/studio";
export const MANAGER_PATH = "/elakay/swipers";

export const STUDIO_TABS = Object.freeze([
  { id: "general", icon: FaInfoCircle, label: () => text("h_dsw_tab_general", "General") },
  { id: "slides", icon: FaImages, label: () => text("h_dsw_tab_slides", "Slides") },
  { id: "design", icon: FaPalette, label: () => text("h_dsw_tab_design", "Design"), workspace: true },
  { id: "elements", icon: FaShapes, label: () => text("h_dsw_tab_elements", "Elements"), workspace: true },
  { id: "animation", icon: FaMagic, label: () => text("h_dsw_tab_animation", "Animation"), workspace: true },
  { id: "responsive", icon: FaMobileAlt, label: () => text("h_dsw_tab_responsive", "Responsive"), workspace: true },
  { id: "settings", icon: FaSlidersH, label: () => text("h_dsw_tab_settings", "Settings") },
  { id: "preview", icon: FaEye, label: () => text("h_dsw_tab_preview", "Preview") },
]);

export const DEFAULT_STUDIO_TAB = "general";
export const isStudioTab = (tab) => STUDIO_TABS.some((entry) => entry.id === tab);
export const studioTab = (tab) => STUDIO_TABS.find((entry) => entry.id === tab) || STUDIO_TABS[0];
export const neighbourTabs = (tab) => {
  const index = STUDIO_TABS.findIndex((entry) => entry.id === tab);
  return { previous: STUDIO_TABS[index - 1] || null, next: STUDIO_TABS[index + 1] || null };
};

// URL of the Studio for a swiper (null = create) and a section.
export const studioUrl = (swiperId, tab = DEFAULT_STUDIO_TAB) => (swiperId
  ? `${STUDIO_PATH}?mode=edit&id=${encodeURIComponent(swiperId)}&tab=${tab}`
  : `${STUDIO_PATH}?mode=create&tab=${tab}`);
